import { EModalName } from '@/helpers/modal';
import { Component } from 'vue-property-decorator';
import EditorBase from '../EditorBase';

@Component({})
export default class GeneralSettings extends EditorBase {
  get hideVerb(): string {
    return this.selectedComponent?.hidden ? 'Show' : 'Hide';
  }

  get hideIcon(): string {
    return this.selectedComponent?.hidden ? 'icon-studio' : 'icon-hide-video';
  }

  get lockVerb(): string {
    return this.selectedComponent?.locked ? 'Unlock' : 'Lock';
  }

  get lockIcon(): string {
    return this.selectedComponent?.locked ? 'icon-unlock' : 'icon-lock';
  }

  openDisconnectConfirmationModal() {
    this.$modal.show(EModalName.disconnectSLConfirmation);
  }
}
